document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.stack-carousel').forEach(function (carousel) {
    const cards = Array.from(carousel.querySelectorAll('.stack-card'));
    const dots = Array.from(carousel.querySelectorAll('.stack-carousel__dot'));
    const speed = (parseFloat(carousel.dataset.autoplay) || 4) * 1000;
    let current = 0;
    let timer;

    function render() {
      cards.forEach((card, i) => {
        card.classList.remove('is-active', 'is-next', 'is-prev');
        if (i === current) {
          card.classList.add('is-active');
        } else if (i === (current + 1) % cards.length) {
          card.classList.add('is-next');
        } else if (i === (current - 1 + cards.length) % cards.length) {
          card.classList.add('is-prev');
        }
      });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
    }

    function next() {
      current = (current + 1) % cards.length;
      render();
    }

    function prev() {
      current = (current - 1 + cards.length) % cards.length;
      render();
    }

    function goTo(index) {
      current = ((index % cards.length) + cards.length) % cards.length;
      render();
    }

    function start() {
      timer = setInterval(next, speed);
    }

    function stop() {
      clearInterval(timer);
    }

    function restart() {
      stop();
      start();
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.goto, 10));
        restart();
      });
    });

    // pause on hover, resume after (desktop)
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);

    // manual swipe / drag support (touch + mouse)
    const track = carousel.querySelector('.stack-carousel__track');
    let startX = 0;
    let isDragging = false;
    const SWIPE_THRESHOLD = 40; // px needed to register a swipe

    function dragStart(x) {
      isDragging = true;
      startX = x;
      stop();
    }

    function dragEnd(x) {
      if (!isDragging) return;
      isDragging = false;
      const diff = x - startX;
      if (diff > SWIPE_THRESHOLD) {
        prev();
      } else if (diff < -SWIPE_THRESHOLD) {
        next();
      }
      start();
    }

    // touch events (mobile)
    track.addEventListener('touchstart', (e) => dragStart(e.touches[0].clientX), { passive: true });
    track.addEventListener('touchend', (e) => dragEnd(e.changedTouches[0].clientX));

    // mouse events (desktop drag)
    track.addEventListener('mousedown', (e) => {
      e.preventDefault();
      dragStart(e.clientX);
    });
    window.addEventListener('mouseup', (e) => {
      if (isDragging) dragEnd(e.clientX);
    });

    // also allow clicking a peeking side card to jump to it directly
    cards.forEach((card) => {
      card.addEventListener('click', function (e) {
        const idx = parseInt(card.dataset.index, 10);
        if (idx !== current) {
          e.preventDefault();
          goTo(idx);
          restart();
        }
        // if it's already the active card, let the link navigate normally
      });
    });

    render();
    start();
  });
});